function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedIn = function SvgLinkedIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "linkedin",
    viewBox: "0 0 66.97 64",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    "data-name": "icon",
    d: "M0,7.43A7,7,0,0,1,2.26,2.1,8.31,8.31,0,0,1,8.15,0,8,8,0,0,1,13.9,2.07a7.27,7.27,0,0,1,2.26,5.56A6.79,6.79,0,0,1,14,12.8,8.3,8.3,0,0,1,8,14.93H8A7.9,7.9,0,0,1,2.2,12.8,7.15,7.15,0,0,1,0,7.43ZM.84,64V20.82H15.19V64Zm22.3,0H37.49V39.89A9.35,9.35,0,0,1,38,36.4a9.39,9.39,0,0,1,2.75-3.72,7,7,0,0,1,4.62-1.52q7.24,0,7.24,9.76V64H67V39.24q0-9.57-4.52-14.51a15.43,15.43,0,0,0-12-4.95,14.68,14.68,0,0,0-13,7.18v.13h-.06l.06-.13V20.82H23.14q.13,2.07.13,12.86T23.14,64Z",
    style: {
      fill: "#ffffff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LinkedIn.ce30591c.svg";
export { ForwardRef as ReactComponent };